import Vue from 'vue'
import VueRouter from 'vue-router'
import IndexPage from './IndexPage'
import AnonUserPage from './AnonUserPage'
import LoginPage from './LoginPage'
import HomePage from './HomePage'
import SignupPage from './SignupPage'
import SettingsPage from './SettingsPage'
import SettingsHubPage from './SettingsHubPage.vue'
import ProductTrackingSettings from './components/settings/ProductTrackingSettings.vue'
import AlertSettings from './components/settings/AlertSettings.vue'
import AccountTeamSettings from './components/settings/AccountTeamSettings.vue'
import SubscriptionBillingSettings from './components/settings/SubscriptionBillingSettings.vue'
import WebhooksSettings from './components/settings/WebhooksSettings.vue'
import ApiKeysSettings from './components/settings/ApiKeysSettings.vue'
import SellersSettings from './components/settings/SellersSettings.vue'
import { tenantIdFromIdentityBody } from './utils/orderVolumeBilling.js'
import ProductSettingsPage from './ProductSettingsPage'
import SubscriptionConfirmPage from './SubscriptionConfirmPage'
import SubscriptionCancelledPage from './SubscriptionCancelledPage'
import ConnectSellerAccountPage from './ConnectSellerAccountPage'
import ConnectInvitePage from './ConnectInvitePage'
// import AutoresponderPage from './AutoresponderPage'
import PasswordResetPage from './PasswordResetPage'
import VerifyEmailPage from './VerifyEmailPage'
import ForgotPasswordPage from './ForgotPasswordPage'
import NewPricingRedeemedPage from './NewPricingRedeemedPage.vue'
import BuyBoxDashboardPage from './BuyBoxDashboardPage.vue'
import AllAlertsPageWrapper from './AllAlertsPageWrapper.vue'
import ProductDetailsPage from './components/ProductDetailsPage.vue'
import ProductsPage from './ProductsPage.vue'
import IssuesPage from './IssuesPage.vue'
import {
  normalizeSubscriptionSummary,
  SUBSCRIPTION_SUMMARY_URL,
  SUBSCRIPTION_RESUME_URL
} from './utils/subscriptionBilling'
import {
  EMAIL_ADDRESSES_URL,
  EMAIL_VERIFICATION_RESEND_URL,
  IDENTITY_SETTINGS_URL,
  emailAddressListFromResponseBody,
  verificationStatusFromAuthBody,
  verificationStatusFromEmailAddresses,
  verificationStatusFromIdentitySettings
} from './utils/emailVerification'
import { createSharedApiSession } from './utils/sharedApiSession'
import { parseAlertCountsHttpPayload } from './utils/watchdogSummaryApi.js'
import StockPage from './StockPage.vue'
import FeeClaimsPage from './FeeClaimsPage.vue'
import PricingCostsPage from './PricingCostsPage.vue'
import WelcomePage from './WelcomePage.vue'
import { amazonAuthorizationQueryMarketplace } from './utils/amazonSellingPartnerOAuth'
import { issuesLocationFromAlertsEmailQuery } from './utils/alertEmailDeepLink.js'
import { maybeFireConnectStoreSuccess, pushGtmEvent } from './utils/gtmEvents'
import { registerCalendlyTracking } from './utils/calendly'
import {
  readPipelineDoneHint,
  readConnectDeferredHint,
  setPipelineDoneHint,
  clearPipelineDoneHint,
  clearOnboardingSessionHints
} from './utils/onboardingSessionHints.js'
import { isConnectInvitePath, isPublicAuthPath, isSignupPath } from './utils/publicAuthRoutes'

import './styles/global.css'
import '../semantic/2.3.1/semantic.min.css'
import '../semantic/2.3.1/semantic.min.js'

import VueResource from 'vue-resource'
import preventAutofill from './directives/preventAutofill.js'
Vue.use(VueResource)
Vue.directive('prevent-autofill', preventAutofill)

import store from './store/index.js'
Vue.use(VueRouter)

var POST_LOGIN_REDIRECT_KEY = 'sk_post_login_redirect'

function capturePostLoginRedirect (path, search) {
  var p = String(path || '')
  if (!p || p === '/' || isPublicAuthPath(p)) return
  var dest = p + (search || '')
  try { sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, dest) } catch (e) {}
}

/** Removes one query param from the address bar without a navigation. */
function stripQueryParam (name) {
  try {
    var url = new URL(window.location.href)
    if (!url.searchParams.has(name)) return
    url.searchParams.delete(name)
    window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash)
  } catch (e) {}
}

function readCookie (name) {
  var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'))
  return match ? decodeURIComponent(match[1]) : null
}

function consumePostLoginRedirect () {
  try {
    var dest = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY)
    sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY)
    if (dest && dest.charAt(0) === '/') return dest
  } catch (e) {}
  return null
}

/** Intercom Identity / Messenger API host (US). Use api-iam.eu / api-iam.au if the workspace is in EU/Australia. */
var INTERCOM_API_BASE = 'https://api-iam.intercom.io'

const routes = [
  {
    path: '/',
    component: AnonUserPage,
    children: [
      {
        path: '/login', component: LoginPage
      }, {
        path: '/signup', component: SignupPage
      }, {
        path: '/ASGTG/signup', component: SignupPage
      }, {
        path: '/asgtg/signup', component: SignupPage
      }, {
        path: '/forgotpassword', component: ForgotPasswordPage
      }, {
        path: '/resetpassword', component: PasswordResetPage
      }, {
        path: '/verify-email', component: VerifyEmailPage
      }
    ]

  }, {
    path: '/connect', component: ConnectSellerAccountPage
  }, {
    path: '/connect/invite/:token', component: ConnectInvitePage
  }, {
    path: '/welcome', component: WelcomePage
  }, {
    path: '/',
    component: IndexPage,
    children: [
      {
        path: '/home', component: BuyBoxDashboardPage, name: 'Home'
      },       {
        path: '/old-dashboard', component: HomePage, name: 'OldDashboard'
      }, {
        path: '/products', component: ProductsPage, name: 'Products'
      }, {
        path: '/issues', component: IssuesPage, name: 'Issues'
      }, {
        path: '/alerts',
        redirect: function (to) {
          return issuesLocationFromAlertsEmailQuery(to.query)
        }
      }, {
        path: '/stock', component: StockPage, name: 'Stock'
      }, {
        path: '/fee-claims', component: FeeClaimsPage, name: 'FeeClaims'
      },       {
        path: '/settings',
        component: SettingsHubPage,
        redirect: function (to) {
          if (to.query && to.query.tab === 'notifications') {
            return { path: '/settings/alerts', query: {} }
          }
          return { path: '/settings/product-tracking' }
        },
        children: [
          { path: 'product-tracking', name: 'SettingsProductTracking', component: ProductTrackingSettings },
          { path: 'account', name: 'SettingsAccount', component: AccountTeamSettings },
          { path: 'alerts', name: 'SettingsAlerts', component: AlertSettings },
          { path: 'sellers', name: 'SettingsSellers', component: SellersSettings },
          { path: 'billing', name: 'SettingsBilling', component: SubscriptionBillingSettings },
          { path: 'bulk-cogs', name: 'SettingsBulkCogs', component: PricingCostsPage },
          { path: 'webhooks', name: 'SettingsWebhooks', component: WebhooksSettings },
          { path: 'api-keys', name: 'SettingsApiKeys', component: ApiKeysSettings }
        ]
      },
      { path: '/productsettings', redirect: '/settings/product-tracking' },
      { path: '/keywordsettings', redirect: '/settings/product-tracking' },
      { path: '/subscription-and-billing', redirect: '/settings/billing' },
      { path: '/pricing-costs', redirect: '/settings/bulk-cogs' }, {
        path: '/all-alerts', component: AllAlertsPageWrapper, name: 'AllAlerts'
      }, {
        path: '/product_details', component: ProductDetailsPage, name: 'ProductDetails'
      }, {
        path: '/subscription', component: SubscriptionConfirmPage, name: 'Subscription'
      }, {
        path: '/cancelsubscription', component: SubscriptionCancelledPage, name: 'SubscriptionCancelled'
      }, {
        path: '/newpricingredeemed', component: NewPricingRedeemedPage, name: 'NewPricingRedeemed'
      }
    ]
  }]

const router = new VueRouter({
  mode: 'history',
  routes: routes
})

/** Pipeline done or “connect later”: / and /login → /home; /home allowed without looping to /welcome. Cleared on logout / 401. */

// Logged-in users: / and /login → /welcome until onboarding is done, then → /home. Allow / right after /login.
router.beforeEach(function (to, from, next) {
  if (document.cookie.search('uliprecheck=1') === -1) {
    return next()
  }
  var path = to.path
  var pipelineDoneHint = readPipelineDoneHint()
  var connectDeferredHint = readConnectDeferredHint()
  var allowHomeLanding = pipelineDoneHint || connectDeferredHint
  if (path === '/' || path === '/login') {
    if (path === '/' && from.path === '/login') return next()
    if (allowHomeLanding) return next({ path: '/home', replace: true })
    return next({ path: '/welcome', replace: true })
  }
  if (path === '/home' && from.path !== '/welcome' && from.path !== '/login' && !allowHomeLanding) {
    return next({ path: '/welcome', replace: true })
  }
  next()
})

const deeplink = window.location.hash // we need preserve the hash, maybe login is needed

// if the user manually navigated to /logout delete the indicator cookie
if (window.location.pathname === '/logout') document.cookie = 'uliprecheck=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'

let params = (new URL(document.location)).searchParams

// TODO: move this to the router object
// re-route user based on the userloggedin cookie
// ( isAuthenticated() will check with the server properly, this is just to prevent flicker )
if (document.cookie.search('uliprecheck=1') === -1 && !isPublicAuthPath(window.location.pathname)) {
  capturePostLoginRedirect(window.location.pathname, window.location.search)
  router.push('/login')
}
if (document.cookie.search('uliprecheck=1') !== -1 && !(window.location.pathname === '/welcome' || window.location.pathname === '/connect' || isConnectInvitePath(window.location.pathname) || window.location.pathname === '/old-dashboard' || window.location.pathname === '/products' || window.location.pathname === '/issues' || window.location.pathname === '/alerts' || window.location.pathname === '/stock' || window.location.pathname === '/settings' || window.location.pathname.indexOf('/settings/') === 0 || window.location.pathname === '/all-alerts' || window.location.pathname === '/product_details' || window.location.pathname === '/forgotpassword' || window.location.pathname === '/resetpassword' || window.location.pathname === '/verify-email' || isSignupPath(window.location.pathname))) {
  var _skLanding = (readPipelineDoneHint() || readConnectDeferredHint()) ? '/home' : '/welcome'
  router.push(_skLanding)
}

// 4. Create and mount the root instance.
// Make sure to inject the router with the router option to make the
// whole app router-aware.
new Vue({
  store,
  router,
  data: function () {
    return {
      deeplink: deeplink,
      offline: false,
      authCompleted: false,
      userEmail: null,
      userFirstName: null,
      userFullName: null,
      userId: null,
      /** Set when a Google (or other SSO) account was just created, so /connect can show the welcome strip once. */
      connectWelcome: null,
      anySellerAccountSetupCompleted: false,
      secondsSinceFirstSellerAccountCreated: null,
      paymentStatus: null,
      facebookPixelInitialized: false,
      facebookPixelEventQueue: [],
      defaultPath: '/home',
      intercomAppId: null,
      amazonCallBackUri: '',
      amazonState: '',
      sellingPartnerId: '',
      hasDailyPricing: false,
      newPricingMessage: '',
      intercomMessengerBooted: false,
      /** True only right before checkIfAuthenticated() after a successful login/signup from a form, so we may leave /login or /signup. */
      pendingPostCredentialsRedirect: false,
      // Blank for Google and Amazon signups: only the email form asks for it.
      accountType: null,
      /** Session token from `/api/auth/csrf` (same as `Vue.http.headers.common[...]`). Exposed for Zapier directory URL query only. */
      apiAccessToken: null,
      /** GET /api/billing/subscription/summary — shared by app shell trial strip and billing. */
      subscriptionSummary: null,
      /** payment-status packageDetails — gates trial strip to Starter/Pro tenants only. */
      billingPackageDetails: null,
      /** From GET /api/identity/settings — used for tenant-specific billing overrides. */
      tenantId: null,
      /** Tenant flag (GET /api/identity/settings): Amazon competitive price alerts + Issues category. */
      competitivePriceAlerts: false,
      /** Tenant flag (GET /api/identity/settings): Fee Claims page + nav item. */
      feeClaims: false,
      /** Fee Claims nav badge: rows in To claim (GET /api/v1/fee-claims/count); null until loaded. */
      feeClaimsToClaimCount: null,
      /** identity / payment-status — gates trial strip to new Starter/Pro billing only. */
      billingUserTypeRaw: null,
      billingSummary: null,
      /** After adding a card, complete PUT /api/billing/subscription/upgrade (`starter` | `pro`). */
      pendingUpgradePlan: null,
      /** null = unknown; false shows verify-account banner across the app shell. */
      emailVerified: null,
      /** Email address shown in the verify banner (usually login email). */
      unverifiedEmail: null,
      /** Scalar id for POST /api/identity/emailverification/:id */
      verificationEmailAddressId: null,
      verificationEmailSent: false,
      verificationEmailSending: false
    }
  },
  methods: {
    applyEmailVerificationStatus: function (status) {
      if (!status) return
      this.emailVerified = !!status.emailVerified
      this.unverifiedEmail = status.email || this.userEmail || null
      if (status.emailAddressId != null && status.emailAddressId !== '') {
        this.verificationEmailAddressId = status.emailAddressId
      }
      if (this.emailVerified) {
        this.verificationEmailSent = false
        this.verificationEmailSending = false
      }
    },
    applyIdentitySettingsBilling: function (body) {
      if (!body || typeof body !== 'object') return
      this.hasDailyPricing = !!body.dailyPricing
      this.competitivePriceAlerts = body.competitivePriceAlerts === true
      this.feeClaims = body.feeClaims === true
      this.tenantId = tenantIdFromIdentityBody(body) || this.tenantId
      var ut =
        body.subscriptionBillingUserType ||
        body.user_type ||
        body.billingUserType ||
        body.billing_user_type ||
        null
      if (ut != null) this.billingUserTypeRaw = ut
    },
    /** Shared GET /api/identity/settings (layout + sidebar + email verification). */
    loadIdentitySettings: function (force) {
      var self = this
      return this._apiSession.get('identitySettings', function () {
        return self.$http.get(IDENTITY_SETTINGS_URL).then(function (res) {
          return res.body || {}
        }, function () {
          return {}
        })
      }, force).then(function (body) {
        self.applyIdentitySettingsBilling(body)
        return body
      })
    },
    /** Fee Claims nav badge (tenants with feeClaims). Pass force after a status change on the page. */
    loadFeeClaimsCount: function (force) {
      var self = this
      if (!this.feeClaims) return Promise.resolve(null)
      return this._apiSession.get('feeClaimsCount', function () {
        return self.$http.get('/api/v1/fee-claims/count').then(function (res) {
          return res.body && res.body.toClaimCount != null ? res.body.toClaimCount : null
        }, function () {
          return null
        })
      }, force).then(function (count) {
        self.feeClaimsToClaimCount = count
        return count
      })
    },
    /** Shared GET /api/identity/email-addresses. */
    loadEmailAddresses: function (force) {
      var self = this
      return this._apiSession.get('emailAddresses', function () {
        return self.$http.get(EMAIL_ADDRESSES_URL).then(function (res) {
          return res.body || {}
        }, function () {
          return {}
        })
      }, force)
    },
    /** Shared GET /api/billing/payment-status. */
    loadPaymentStatus: function (force) {
      var self = this
      var tz = 0 - new Date().getTimezoneOffset()
      return this._apiSession.get('paymentStatus:' + tz, function () {
        return self.$http.get('/api/billing/payment-status', {
          params: { timezoneOffsetMinutes: tz }
        }).then(function (res) {
          return res.body || {}
        }, function () {
          return {}
        })
      }, force)
    },
    /** Shared GET /api/v1/sellers — filters + Model.Sellers + Issues. */
    loadV1Sellers: function (force) {
      var self = this
      return this._apiSession.get('v1Sellers', function () {
        return self.$http.get('/api/v1/sellers').then(function (res) {
          return res.body || {}
        }, function () {
          return null
        })
      }, force)
    },
    /** Shared GET /api/v1/onboarding/status (main + IndexPage). Pass force on poll. */
    loadOnboardingStatus: function (force) {
      var self = this
      return this._apiSession.get('onboardingStatus', function () {
        return self.$http.get('/api/v1/onboarding/status').then(function (res) {
          return res.body || {}
        }, function () {
          return null
        })
      }, force)
    },
    /**
     * Load verification from identity APIs (settings + email-addresses).
     * If either source says verified, hide the banner. Keeps `emailVerified`
     * null until at least one API answers for the login email.
     * Result is cached until force=true (e.g. tab focus while banner visible).
     */
    loadEmailVerificationStatus: function (force) {
      var self = this
      if (!this.userEmail && !this.authCompleted) {
        return Promise.resolve(null)
      }
      if (!force && this._emailVerificationResolved !== undefined) {
        return Promise.resolve(this._emailVerificationResolved)
      }
      if (!force && this._emailVerificationLoadPromise) return this._emailVerificationLoadPromise
      if (force) {
        this._apiSession.clear('identitySettings')
        this._apiSession.clear('emailAddresses')
        this._emailVerificationResolved = undefined
      }

      function fromEmailAddresses () {
        return self.loadEmailAddresses(force).then(function (body) {
          return verificationStatusFromEmailAddresses(
            emailAddressListFromResponseBody(body),
            self.userEmail
          )
        }, function () {
          return null
        })
      }

      function fromSettings () {
        return self.loadIdentitySettings(force).then(function (body) {
          return verificationStatusFromIdentitySettings(body, self.userEmail || body.email)
        }, function () {
          return null
        })
      }

      this._emailVerificationLoadPromise = Promise.all([fromSettings(), fromEmailAddresses()]).then(function (results) {
        var settingsStatus = results[0]
        var emailsStatus = results[1]
        var status = null
        // Prefer an explicit verified=true from either API (settings can lag after verify).
        if (emailsStatus && emailsStatus.emailVerified === true) status = emailsStatus
        else if (settingsStatus && settingsStatus.emailVerified === true) status = settingsStatus
        else if (emailsStatus) status = emailsStatus
        else if (settingsStatus) status = settingsStatus
        if (status) self.applyEmailVerificationStatus(status)
        self._emailVerificationResolved = status
        self._emailVerificationLoadPromise = null
        return status
      }, function (err) {
        self._emailVerificationLoadPromise = null
        return Promise.reject(err)
      })
      return this._emailVerificationLoadPromise
    },
    loadEmailVerificationFromSettings: function () {
      var self = this
      return this.loadIdentitySettings().then(function (body) {
        var status = verificationStatusFromIdentitySettings(body, self.userEmail || body.email)
        if (status) self.applyEmailVerificationStatus(status)
        return status
      }, function () {
        return null
      })
    },
    resendEmailVerification: function () {
      var self = this
      var email = this.unverifiedEmail || this.userEmail
      if (!email) {
        return this.loadEmailVerificationStatus().then(function () {
          if (!self.unverifiedEmail && !self.userEmail) {
            return Promise.reject(new Error('Missing email for verification'))
          }
          return self.resendEmailVerification()
        })
      }
      if (this.verificationEmailSending) return Promise.resolve()
      this.verificationEmailSending = true
      return this.$http.post(EMAIL_VERIFICATION_RESEND_URL, { email: email }).then(function () {
        self.verificationEmailSending = false
        self.verificationEmailSent = true
      }, function (err) {
        self.verificationEmailSending = false
        return Promise.reject(err)
      })
    },
    loadSubscriptionSummary: function (force) {
      var self = this
      if (!this.authCompleted && !this.userEmail) {
        return Promise.resolve(null)
      }
      return this._apiSession.get('subscriptionSummary', function () {
        return self.$http.get(SUBSCRIPTION_SUMMARY_URL).then(function (res) {
          return normalizeSubscriptionSummary(res.body || {})
        }, function () {
          return null
        })
      }, force).then(function (summary) {
        self.subscriptionSummary = summary
        self.$emit('subscription-summary-updated', self.subscriptionSummary)
        return self.subscriptionSummary
      })
    },
    /** Undo scheduled cancellation (`cancel_at_period_end`) and restore active subscription. */
    resumeSubscription: function () {
      var self = this
      return this.$http.put(SUBSCRIPTION_RESUME_URL).then(function () {
        return self.loadSubscriptionSummary(true).then(function (summary) {
          self.$emit('subscription-resumed', summary)
          return summary
        })
      })
    },
    /**
     * Google sign-in lands on its return path with ?sso=<one-time code>; trade it for the JWT
     * cookies on this host before the normal auth check. New accounts then follow the email-signup
     * path (→ /connect, or the Appstore handoff); returning users go to their deep link or /.
     */
    claimSsoLogin: function () {
      var code = new URL(window.location.href).searchParams.get('sso')
      if (!code) return Promise.resolve()
      stripQueryParam('sso')
      var never = new Promise(function () {})
      return this.$http.post('/api/auth/sso/claim', { code: code }).then(
        (response) => {
          var midAppstoreHandoff = isSignupPath(window.location.pathname) && new URL(window.location.href).searchParams.get('amazon_callback_uri')
          if (response.body && (response.body.newAccount || midAppstoreHandoff)) {
            this.pendingPostCredentialsRedirect = true
            return
          }
          window.location.assign(window.location.origin + (consumePostLoginRedirect() || '/'))
          return never
        },
        (response) => {
          var reason = response.status === 423 ? 'account_locked' : 'google_expired'
          var url = new URL(window.location.href)
          url.searchParams.set('sso_error', reason)
          window.location.replace(url.pathname + url.search)
          return never
        }
      )
    },
    /** Set by the backend on new Google accounts only; fire the signup conversion once. */
    trackSsoSignup: function () {
      var method = readCookie('sk_sso_signup')
      if (!method || !this.userEmail) return
      document.cookie = 'sk_sso_signup=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
      this.connectWelcome = method
      pushGtmEvent({ event: 'sign_up_account_created', step: 1, method: method })
      try { window.fpr('referral', { email: this.userEmail }) } catch (e) { /* noop */ }
    },
    checkIfAuthenticated: function () {
      this.$http.get('/api/auth/isauthenticated').then((response) => {
        // Logged out is a 200 { authenticated: false }, not a 401. Treat it as signed out so public
        // pages (/signup, /login) make no signed-in-only calls and never start Amazon on load.
        if (!response.body || response.body.authenticated === false || !response.body.email) {
          this.pendingPostCredentialsRedirect = false
          this.handleSignedOut(response)
          return
        }
        var allowRedirectsFromAuthPages = this.pendingPostCredentialsRedirect
        this.pendingPostCredentialsRedirect = false
        // console.log('qweqwe', response.body)
        this.userEmail = response.body.email
        this.userFirstName = response.body.firstName || null
        this.userFullName = response.body.fullName || null
        this.userId = response.body.userId || null
        this.accountType = response.body.accountType || null
        this.trackSsoSignup()
        this.tenantId = tenantIdFromIdentityBody(response.body) || this.tenantId
        // Auth may omit or mis-report verification — only trust an explicit "verified"
        // here; identity APIs below are the source of truth for the banner.
        var authVerify = verificationStatusFromAuthBody(response.body)
        if (authVerify && authVerify.emailVerified === true) {
          this.applyEmailVerificationStatus(authVerify)
        }
        setTimeout(() => { this.$http.post('/api/auth/extend').then((response) => {}, (response) => {}) }, 60000)
        setInterval(() => { this.$http.post('/api/auth/extend').then((response) => {}, (response) => {}) }, 2700000)

        this.anySellerAccountSetupCompleted = response.body.anySellerAccountSetupCompleted
        this.paymentStatus = response.body.paymentStatus // 0 -> no payment needed on current plan
        this.secondsSinceFirstSellerAccountCreated = response.body.secondsSinceFirstSellerAccountCreated
        // After Amazon OAuth return: fire connect_store_success once (Authorize click set a session flag)
        if (this.anySellerAccountSetupCompleted &&
            this.secondsSinceFirstSellerAccountCreated != null &&
            this.secondsSinceFirstSellerAccountCreated < 9999) {
          maybeFireConnectStoreSuccess()
        }
        // New users (recent signup) should land on /welcome; keep /home for established users
        if (response.body.defaultPath) {
          this.defaultPath = response.body.defaultPath
        } else if (this.secondsSinceFirstSellerAccountCreated != null && this.secondsSinceFirstSellerAccountCreated < 9999) {
          this.defaultPath = '/welcome'
        } else {
          this.defaultPath = '/home'
        }
        this.readAppstoreHandoffParams()

        var goRootAfterLogin = allowRedirectsFromAuthPages && this.$route.path === '/login'
        // A signed-in user opened /signup again ("Start free trial" on the site, an email link).
        // Send them on instead of starting Amazon. The Appstore handoff and ?finish=amazon keep
        // their own handling below / in SignupPage.
        var reopenedSignup = isSignupPath(this.$route.path) && !allowRedirectsFromAuthPages &&
          this.$route.query.finish !== 'amazon' &&
          !this.amazonCallBackUri && !this.amazonState && !this.sellingPartnerId

        if (goRootAfterLogin) {
          this.fbPixelEventHandler('custom', 'LoggedInToApp')
          var afterLogin = consumePostLoginRedirect() || '/'
          window.location.assign(window.location.origin + afterLogin)
          return
        } else if (reopenedSignup) {
          this.$router.replace(this.anySellerAccountSetupCompleted ? '/home' : { path: '/connect', query: { from: 'signup' } })
          this.fbPixelEventHandler('custom', 'LoggedInToApp')
        } else if (this.secondsSinceFirstSellerAccountCreated) {
          // Only redirect if not already on an authenticated page; new users go to welcome first
          const authenticatedPages = ['/home', '/welcome', '/old-dashboard', '/products', '/issues', '/alerts', '/stock', '/settings', '/all-alerts', '/product_details']
          var isOnAuthPage = authenticatedPages.includes(this.$route.path) || this.$route.path.indexOf('/settings/') === 0
          if (!isOnAuthPage && !isPublicAuthPath(this.$route.path) && this.$route.path !== '/connect') {
            this.$router.push('/welcome')
          }
          this.$root.$emit('fb-pixel-event', 'custom', 'LoggedInToApp')
          setTimeout(() => {
            console.log('[Main] Authentication complete, loading dashboard stats')
            this.loadDashboardStats()
          }, 1000)
        } else if ((this.paymentStatus === 1 || !this.anySellerAccountSetupCompleted) && !readConnectDeferredHint() && (!isPublicAuthPath(this.$route.path) || allowRedirectsFromAuthPages)) {
          this.$router.push('/connect')
          this.fbPixelEventHandler('custom', 'LoggedInToApp')
          setTimeout(() => {
            console.log('[Main] Authentication complete, loading dashboard stats')
            this.loadDashboardStats()
          }, 1000)
        } else if (this.amazonCallBackUri !== '') {
          const qp = this.$route.query
          const region = qp.region || 'NA'
          const data = {
            path: this.$route.path,
            accName: '',
            expectedSellerKey: this.sellingPartnerId,
            amazonState: this.amazonState,
            amazonCallbackUrl: this.amazonCallBackUri,
            region: region,
            marketplace: amazonAuthorizationQueryMarketplace(region, qp.marketplace)
          }
          this.$http.get('/api/identity/amazon/authorization/redirect', {params: data}).then((response) => {
            this.clearAmazon()
            window.location = response.body.location
            return
          }, (response) => {
            this.clearAmazon()
            this.clicked = null
            this.$emit('error', response.body.message)
          })
        } else if (!isPublicAuthPath(this.$route.path) && this.$route.path !== '/connect' && this.$route.path !== '/home' && this.$route.path !== '/welcome' && this.$route.path !== '/settings' && this.$route.path.indexOf('/settings/') !== 0 && this.$route.path !== '/all-alerts' && this.$route.path !== '/product_details' && this.$route.path !== '/issues' && this.$route.path !== '/alerts') {
          this.$router.push('/welcome')
          this.fbPixelEventHandler('custom', 'LoggedInToApp')
          // Load dashboard stats after successful authentication
          setTimeout(() => {
            console.log('[Main] Authentication complete, loading dashboard stats')
            this.loadDashboardStats()
          }, 1000)
        } else {
          this.fbPixelEventHandler('custom', 'LoggedInToApp')
          // Load dashboard stats after successful authentication
          setTimeout(() => {
            console.log('[Main] Authentication complete, loading dashboard stats')
            this.loadDashboardStats()
          }, 1000)
        }
        // When on /, /welcome, or /home: align with onboarding status (dashboard vs welcome)
        if (!goRootAfterLogin &&
            (this.$route.path === '/' || this.$route.path === '/welcome' || this.$route.path === '/home') &&
            this.paymentStatus !== 1 && this.anySellerAccountSetupCompleted && !this.amazonCallBackUri) {
          this.loadOnboardingStatus().then(
            (data) => {
              if (!data) return
              var pipelineDone = !!data.completed ||
                (!!data.sellerConnected && !!data.productsImported && !!data.buyboxFetched && !!data.ordersFetched)
              var path = this.$route.path
              if (pipelineDone) {
                setPipelineDoneHint()
                if (path === '/welcome' || path === '/') {
                  this.$router.replace('/home')
                }
                return
              }
              clearPipelineDoneHint()
              if (path === '/home' && !readConnectDeferredHint()) {
                this.$router.push('/welcome')
              }
            },
            () => {}
          )
        }
        // redirect if no payment: if (this.paymentStatus === 99) this.$router.push('/settings')
        this.authCompleted = true
        this.intercomAppId = response.body.intercomAppId || process.env.INTERCOM_APP_ID
        // Non-critical shell work after first paint so /home and /issues can fetch first.
        var self = this
        var intercomEmail = this.userEmail
        var intercomHash = response.body.userHash
        var intercomJwt = response.body.intercom_user_jwt || response.body.intercomUserJwt
        this.scheduleAfterFirstPaint(function () {
          self.loadSubscriptionSummary()
          self.loadEmailVerificationStatus()
          self.getDailyBillingStatus()
          self.loadIntercom(intercomEmail, intercomHash, intercomJwt)
        })
      }, (response) => {
        this.handleSignedOut(response)
      })
    },
    /** Appstore-started OAuth (/signup?amazon_callback_uri=…): keep its params for the handoff. Missing params stay ''. */
    readAppstoreHandoffParams: function () {
      if (!isSignupPath(this.$route.path)) return
      var params = this.$route.query
      this.amazonCallBackUri = params.amazon_callback_uri || ''
      this.amazonState = params.amazon_state || ''
      this.sellingPartnerId = params.selling_partner_id || ''
    },
    /** isauthenticated says signed out: a 401/403, or a 200 { authenticated: false }. */
    handleSignedOut: function (response) {
      this.readAppstoreHandoffParams()
      // TODO: move this to the router object
      if (response.status === 0) {
        // request was cancelled, do nothing
        return
      }
      document.cookie = 'uliprecheck=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;' // this deletes the loginprecheck cookie
      clearOnboardingSessionHints()
      var signedOut = response.status === 401 || response.status === 403 || !!(response.body && response.body.authenticated === false)
      if (signedOut) {
        if (!isPublicAuthPath(this.$route.path)) {
          capturePostLoginRedirect(this.$route.fullPath)
          this.$router.push('/login')
        }
      } else {
        console.log('Unexpected error status: ' + response.status)
        // if (this.offline) window.alert('Something didn\'t happen :( Please notify support you saw this message.')
      }
      this.authCompleted = false
      this.intercomAppId = (response.body && response.body.intercomAppId) || null
      this.resetIntercom()
    },
    /** Prefetch unfiltered Issues sidebar counts (e.g. Alerts nav hover). */
    prefetchIssuesAlertCounts: function () {
      var self = this
      if (!this._apiSession) this._apiSession = createSharedApiSession()
      return this._apiSession.get('prefetchAlertCounts', function () {
        return self.$http.get('/api/v1/watchdogs/summary/alert_counts', {
          params: { time_range: 'all_time', _cb: Date.now() },
          headers: {
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache'
          }
        }).then(function (res) {
          var payload = parseAlertCountsHttpPayload(res)
          self._prefetchedAlertCounts = {
            payload: payload,
            at: Date.now(),
            filterKey: 'all'
          }
          return payload
        }, function () {
          return null
        })
      })
    },
    /** Run non-critical work after the browser paints (or within ~2s). */
    scheduleAfterFirstPaint: function (fn) {
      if (typeof fn !== 'function') return
      var run = function () {
        try { fn() } catch (err) { console.error('[scheduleAfterFirstPaint]', err) }
      }
      var kick = function () {
        if (typeof window.requestIdleCallback === 'function') {
          window.requestIdleCallback(run, { timeout: 2000 })
        } else {
          setTimeout(run, 50)
        }
      }
      if (typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(kick)
        })
      } else {
        setTimeout(kick, 0)
      }
    },
    getDailyBillingStatus: function () {
      this.$http.get('/api/billing/daily-billing-status').then(res => {
        this.hasDailyPricing = res.body.hasDailyPricing === true
        this.newPricingMessage = res.body.message
      }, res => {
        this.error = res.body.message
        console.info('Error while trying to get daily billing status')
      })
    },
    clearAmazon: function () {
      this.sellingPartnerId = ''
      this.amazonCallBackUri = ''
      this.amazonState = ''
    },
    /** Shared logout for Welcome page, signup banner, etc. IndexPage may clear timers before calling this. */
    signOutUser: function (redirectPath) {
      var dest = typeof redirectPath === 'string' && redirectPath.charAt(0) === '/' ? redirectPath : '/login'
      this.$http.get('/api/auth/signout').then(() => {})
      document.cookie = 'uliprecheck=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
      clearOnboardingSessionHints()
      try { sessionStorage.removeItem('worldStore') } catch (e) {}
      this.authCompleted = false
      this.userEmail = null
      this.userFirstName = null
      this.userFullName = null
      this.userId = null
      this.connectWelcome = null
      this.subscriptionSummary = null
      this.billingPackageDetails = null
      this.pendingUpgradePlan = null
      this.emailVerified = null
      this.unverifiedEmail = null
      this.verificationEmailAddressId = null
      this.verificationEmailSent = false
      this.verificationEmailSending = false
      this._emailVerificationResolved = undefined
      this._emailVerificationLoadPromise = null
      if (this._apiSession) this._apiSession.clear()
      this.resetIntercom()
      this.$router.push(dest)
    },
    fbPixelInit: function () {
      if (this.facebookPixelInitialized) return
      /* eslint-disable */
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window,document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      window.fbq('init', '2279917682283795');
      window.fbq('track', 'PageView');
      /* eslint-enable */
      this.facebookPixelInitialized = true
      for (var i = 0; i < this.facebookPixelEventQueue.length; ++i) {
        const e = this.facebookPixelEventQueue[i]
        this.fbPixelEventHandler(e.type, e.event, e.params)
      }
      this.facebookPixelEventQueue = []
    },
    fbPixelEventHandler: function (type, event, params) {
      if (this.facebookPixelInitialized) {
        const operation = type === 'standard' ? 'track' : 'trackCustom'
        if (params) window.fbq(operation, event, params)
        else window.fbq(operation, event)
      } else {
        this.facebookPixelEventQueue.splice(this.facebookPixelEventQueue.length, 0, {type: type, event: event, params: params})
      }
    },
    /**
     * @param {string|null} userEmail
     * @param {string|null|undefined} userHash - Legacy HMAC identity verification (must match Intercom docs for the identifier you hash).
     * @param {string|null|undefined} intercomUserJwt - Preferred: Messenger Security JWT from your API (Settings → Messenger → Security). Do not send both JWT and user_hash from the backend.
     */
    loadIntercom: function (userEmail, userHash, intercomUserJwt) {
      var appId = this.intercomAppId || process.env.INTERCOM_APP_ID
      var self = this
      if (!appId) {
        this.intercomMessengerBooted = false
        return
      }
      if (typeof window.Intercom !== 'function') {
        this.intercomMessengerBooted = false
        return
      }
      var jwt = intercomUserJwt && String(intercomUserJwt).trim() ? String(intercomUserJwt).trim() : null
      var runBoot = function () {
        if (typeof window.Intercom !== 'function') return
        var baseSettings = { api_base: INTERCOM_API_BASE, app_id: appId }
        try {
          window.Intercom('shutdown')
        } catch (e) {}
        // JWT and user_hash/email must never be merged (snippet or prior boot can leave stale keys → 400).
        // name on every identified boot. user_id goes with the legacy hash only:
        // the JWT already carries user_id, and sending it again makes Intercom return 400.
        var identity = {}
        if (self.userFullName) identity.name = self.userFullName
        if (jwt) {
          window.intercomSettings = Object.assign({}, baseSettings)
          window.Intercom('boot', Object.assign({
            api_base: INTERCOM_API_BASE,
            app_id: appId,
            intercom_user_jwt: jwt
          }, identity))
        } else if (userEmail && userHash) {
          if (self.userId) identity.user_id = self.userId
          window.intercomSettings = Object.assign({}, baseSettings)
          window.Intercom('boot', Object.assign({
            api_base: INTERCOM_API_BASE,
            app_id: appId,
            email: userEmail,
            user_hash: userHash
          }, identity))
        } else {
          window.intercomSettings = Object.assign({}, baseSettings)
          window.Intercom('boot', {
            api_base: INTERCOM_API_BASE,
            app_id: appId
          })
        }
        self.intercomMessengerBooted = true
      }
      // Defer boot to after the loader has injected the widget script (same window "load" tick or later).
      var scheduleBoot = function () {
        setTimeout(runBoot, 0)
      }
      if (document.readyState === 'complete') {
        scheduleBoot()
      } else {
        window.addEventListener('load', function onLoadIntercom () {
          window.removeEventListener('load', onLoadIntercom)
          scheduleBoot()
        })
      }
    },
    resetIntercom: function () {
      this.intercomMessengerBooted = false
      if (typeof window.Intercom !== 'function') return
      window.Intercom('shutdown')
      var appId = this.intercomAppId || process.env.INTERCOM_APP_ID
      if (!appId) return
      window.intercomSettings = {
        api_base: INTERCOM_API_BASE,
        app_id: appId
      }
      window.Intercom('boot', {
        api_base: INTERCOM_API_BASE,
        app_id: appId
      })
      this.intercomMessengerBooted = true
    },
    showIntercom: function () {
      if (typeof window.Intercom !== 'function') return
      window.Intercom('show')
    },
    loadDashboardStats: function () {
      console.log('[Main] loadDashboardStats called - pre-loading stats for better UX')
      // COMMENTED OUT: Call dashboard stats API directly and store globally
      /* this.$http.get('/api/sentinel/stateoftheworld', {
        params: { statsOnly: true }
      }).then((response) => {
        console.log('[Main] Dashboard stats loaded:', response.body)
        // Store stats globally for Dashboard component to access
        this.$root.dashboardStats = response.body
        // Emit event to notify Dashboard component
        this.$root.$emit('dashboard-stats-loaded', response.body)
      }).catch((error) => {
        console.error('[Main] Failed to load dashboard stats:', error)
      }) */
    }
  },
  created: function () {
    registerCalendlyTracking()
    // Vue 2 does not proxy data keys starting with `_`; keep session cache on the instance.
    this._apiSession = createSharedApiSession()
    this._emailVerificationResolved = undefined
    Vue.http.interceptors.push((request, next) => {
      if (this.loginNeeded && request.url !== '/api/auth/login/standard') {
        this.log('Login needed, suppressing request ' + request.method + ' ' + request.url)
        return
      }
      next((response) => {
        if (response.ok === false &&
          (response.status === 0 || response.status === 502 || response.status === 503 || response.status === 504 ||
          (response.status === 500 && response.body.startsWith('Error occured while trying to proxy to')))) {
          if (this.offline === false) this.offline = true
        } else if (this.offline) {
          this.offline = false
        }
      })
    })
    this.$http.get('/api/auth/csrf').then((response) => {
      const t = response.body
      this.apiAccessToken = t.token
      Vue.http.headers.common[t.headerName] = t.token
      if (window.location.pathname === '/logout') {
        this.$http.get('/api/auth/signout').then((response) => {
          window.location('/login')
        })
      } else {
        this.claimSsoLogin().then(() => this.checkIfAuthenticated())
      }
    }, (response) => {
      if (typeof console === 'object' && typeof console.log === 'function') {
        console.log('errors')
        console.log(response)
      }
      // TODO: add offline componenet here
      if (this.offline) document.write('Your connection seems to be down at the moment.')
    })
    window.onerror = (message, url, lineNumber, columnNumber, error) => {
      this.$http.post('/api/webui/p0/rjse', {
        message: message,
        url: url,
        lineNumber: lineNumber,
        columnNumber: columnNumber,
        error: error,
      })
      return false // let the default error handler run
    }
    window.onbeforeunload = function (evt) {
      if (window.dirty) {
        var message = 'Are you sure you want to leave? You have some unsaved changes.'
        if (typeof evt === 'undefined') {
          evt = window.event
        }
        if (evt) {
          evt.returnValue = message
        }
        return message
      }
    }
    this.$on('fb-pixel-event', this.fbPixelEventHandler)
    var self = this
    this.$router.afterEach(function () {
      if (self.authCompleted && self.intercomMessengerBooted && typeof window.Intercom === 'function') {
        try {
          window.Intercom('update')
        } catch (e) {}
      }
    })
  },
  mounted: function () {
    var self = this
    this.scheduleAfterFirstPaint(function () {
      self.fbPixelInit()
    })
  }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js